import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  
  // Leemos el rol que guardamos en el localStorage durante el Login
  const userRole = localStorage.getItem('rol');

  // Evita parpadeos mientras React revisa la sesión
  if (loading) return <div style={{ color: '#fff', textAlign: 'center', marginTop: '50px' }}>Verificando permisos de seguridad...</div>;

  // FILTRO 1: Si no está logueado, lo mandamos a iniciar sesión
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // FILTRO 2 (EL CANDADO ESTRICTO): Si está logueado pero NO es admin, lo expulsamos a la tienda
  if (userRole !== 'admin') {
    return <Navigate to="/" replace />;
  }

  // Si pasa ambos filtros, le damos acceso al panel de control
  return children;
};

export default ProtectedRoute;